import { Component, ViewChild, Input } from '@angular/core';
import { DriverCard, Drivers, Trailers, Trucks } from '../../interfaces';
import { MessageService } from 'primeng/api';
import { DataServiceService } from '../../services/data-service.service';
import { AssignEquipmentComponent, EquipmentAssignmentResult } from '../../equipment/assign-equipment/assign-equipment.component';


@Component({
  selector: 'app-equipment-edit-dialog',
  templateUrl: './equipment-edit-dialog.component.html',
  styleUrl: './equipment-edit-dialog.component.scss'
})

export class EquipmentEditDialogComponent {

constructor(private messageService: MessageService, private dataServiceService: DataServiceService) {}

@ViewChild('equipmentAssigner') equipmentAssigner!: AssignEquipmentComponent;


@Input() trailers: Trailers[] = [];
@Input() trucks: Trucks[] = [];
@Input() drivers: Drivers[] = [];
@Input() driverCards: DriverCard[] = [];

showEditTruckDialog = false;
showEditTrailerDialog = false;

selectedDriver: number = 0;   // The ID of the Driver receiving the equipment assignment
selectedTrailer: string = '';

selectedTruckId: any;
selectedTrailerId: any;


getTruckNumber(driverId: number): string {
  // Find the driver first to get their assigned truck
  const driver = this.drivers.find(d => d.driver_id === driverId);
  if (!driver || !driver.truck_id) return 'No Truck Assigned';
  
  // Then find the truck using the driver's truck_id
  const truck = this.trucks.find(t => t.truck_id === driver.truck_id);
  return truck?.truck_number || 'No Truck Assigned';
}


editTruck(driverId: number) {
  this.showEditTruckDialog = true;

  this.selectedDriver = driverId; // The ID of the Driver receiving the equipment assignment

  const driver = this.drivers.find(d => d.driver_id === driverId); // The driver object

  this.selectedTruckId = driver?.truck_id || null; // The truck ID of the driver

  return this.selectedTruckId;
}


saveEditTruck(driverId: number) {
  // Find the selected driver and truck
  const driverCard = this.driverCards.find(d => d.driver.driver_id === driverId);
  const fullDriver = this.drivers.find(d => d.driver_id === driverId);
  const selectedTruck = this.trucks.find(t => t.truck_id === this.selectedTruckId);

  // Validate that we have a driver and a truck selection
  if (!driverCard || !fullDriver) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Invalid driver selection'
    });
    return;
  }

  if (!selectedTruck || !this.selectedTruckId) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Please select a truck to assign'
    });
    return;
  }

  // Use the assign-equipment component to handle the assignment
  this.equipmentAssigner.assignTruckToDriver(
    fullDriver,
    selectedTruck,
    (result: EquipmentAssignmentResult) => {
      // Success callback
      console.log('Truck assignment successful:', result);
      this.showEditTruckDialog = false;
      
      // Refresh driver data to show the updated assignment
      this.dataServiceService.refreshDriverCards();
    },
    (error) => {
      // Error callback
      console.error('Truck assignment failed:', error);
      // The assign-equipment component already shows error messages
    }
  );
}



getTrailerNum(driverId: number): string {
  if (!this.trailers) {
    return 'No Trailer Assigned';
  }
  
  // Find the driver first to get their assigned trailer
  const driver = this.drivers.find(d => d.driver_id === driverId);
  if (!driver || !driver.trailer_id) return 'No Trailer Assigned';
  
  // Then find the trailer using the driver's trailer_id
  const trailer = this.trailers.find(t => t.trailer_id === driver.trailer_id);
  return trailer?.trailer_number || 'No Trailer Assigned';
}


editTrailer(driverId: number) {
  this.showEditTrailerDialog = true;

  this.selectedDriver = driverId;
  console.log('selectedDriver', this.selectedDriver);

  this.selectedTrailerId = this.drivers.find(d => d.driver_id === driverId)?.trailer_id || null;
  console.log('selectedTrailerId', this.selectedTrailerId);

  return this.selectedTrailerId;
}


saveEditTrailer() {
  // Find the selected driver and trailer
  const fullDriver = this.drivers.find(d => d.driver_id === this.selectedDriver);
  const selectedTrailer = this.trailers.find(t => t.trailer_id === this.selectedTrailerId);


  // Validate that we have a driver and a trailer selection
  if ( !fullDriver) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Invalid driver selection'
    });
    return;
  }

  if (!selectedTrailer || !this.selectedTrailerId) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Please select a trailer to assign'
    });
    return;
  }

  // Use the assign-equipment component to handle the assignment
  this.equipmentAssigner.assignTrailerToDriver(
    fullDriver,
    selectedTrailer,
    (result: EquipmentAssignmentResult) => {
      // Success callback
      console.log('Trailer assignment successful:', result);
      this.showEditTrailerDialog = false;
      
      // Refresh driver data to show the updated assignment
      this.dataServiceService.refreshDriverCards();
    },
    (error) => {
      // Error callback
      console.error('Trailer assignment failed:', error);
      // The assign-equipment component already shows error messages
    }
  );
}


}